import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ArrowUpToolTip = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 78}
          height={props.height ?? 79}
          viewBox="0 0 61 68"
          fill="none"
          {...props}
        >
          <Path
            d="M33.8564 23.397L34.2803 21.0017C34.5042 19.5265 34.8205 18.3032 35.0172 17.2699L35.298 15.8588L35.5637 14.7317C35.7103 14.0669 35.808 13.5549 35.8658 13.164C36.1061 11.602 35.6933 11.9821 35.368 11.891C35.0427 11.7999 34.9104 11.2895 34.2503 12.7992C34.0912 13.1762 33.8962 13.6797 33.6602 14.3465L33.2631 15.4745L32.8772 16.8994C32.6003 17.9359 32.2449 19.2055 31.978 20.7217L31.5124 23.1818C31.3674 24.0767 31.2622 25.0238 31.118 26.0502C30.5307 30.8629 30.4047 35.7207 30.7418 40.5574C31.1156 45.7971 32.048 50.9819 33.5231 56.0235C34.6733 60.0359 36.2224 63.923 38.1471 67.6267C38.7104 68.7385 39.3358 69.8178 40.0202 70.8595C40.4959 71.6042 40.7904 71.9913 40.8519 71.9527C41.2304 71.7556 37.3862 64.9766 35.1324 55.5011C33.9097 50.5189 33.1717 45.4301 32.9288 40.3057C32.7132 35.5911 32.8954 30.8666 33.4733 26.1826L33.8487 23.4194"
            fill="black"
          />
          <Path
            d="M39.8211 14.6606C41.2363 17.065 42.5593 19.187 43.6916 20.9172C45.9982 24.453 47.6527 26.5068 48.0879 26.2524C48.5231 25.998 47.6784 23.4968 45.9309 19.6276C45.0609 17.6978 43.9738 15.4425 42.719 12.9466C42.0709 11.6915 41.4546 10.4581 40.666 9.01844C40.1841 8.08607 39.4561 7.30345 38.561 6.75542C37.908 6.39485 37.1627 6.236 36.4195 6.29899C35.708 6.36829 35.0204 6.59303 34.4053 6.95727C33.5941 7.48817 32.8216 8.0759 32.0935 8.71603C31.4136 9.23332 30.7854 9.81859 30.1618 10.3697C28.9221 11.4815 27.7383 12.5661 26.6521 13.6379C24.4625 15.779 22.6189 17.8104 21.142 19.5781C18.1956 23.1232 16.7478 25.5741 17.1013 25.8573C17.4547 26.1405 19.5849 24.2438 22.9179 21.1867C24.5892 19.6545 26.5298 17.8714 28.8108 15.8908C29.9196 14.9092 31.1112 13.8953 32.349 12.8616L34.2325 11.3059C34.7983 10.8145 35.3953 10.3603 36.0198 9.94621C36.4966 9.70615 36.3944 9.75321 36.6268 9.83705C37.0382 10.1161 37.3758 10.4907 37.6108 10.9288C38.3592 12.2149 39.0855 13.472 39.7795 14.6462"
            fill="black"
          />
        </Svg>
      </View>
    );
  },
);

export { ArrowUpToolTip };
